import { createContext } from "react";
import type { AppContextType } from "../../@types";

export const AppContext = createContext({} as AppContextType);

export const AppStore = {
  AppContext,
};
